export default __webpack_public_path__ + "static/media/FontsFree-Net-hk-nova-regular-r.2944e264.ttf";